import JSEncrypt from './cos_jsencrypt'
// import config from '/config'
// import $ from '@/common'

function checkIdNo(sId, force18) {
  var aCityStr = "11,12,13,14,15,21,22,23,31,32,33,34,35,36,37,41,42,43,44,45,46,50,51,52,53,54,61,62,63,64,65,71,81,82,91";
  var sBirthday;
  // 18位身份证判断
  if (sId.length == 18) {
    var iSum = 0;
    if (!/^\d{17}(\d|x)$/i.test(sId))
      return false;
    sId = sId.replace(/x$/i, "a");
    if (aCityStr.indexOf(sId.substr(0, 2)) === -1)
      return false;
    sBirthday = sId.substr(6, 4) + "-" + Number(sId.substr(10, 2)) + "-" + Number(sId.substr(12, 2));
    var d = new Date(sBirthday.replace(/-/g, "/"));
    if (sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()))
      return false;
    for (var i = 17; i >= 0; i--)
      iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11);
    if (iSum % 11 != 1)
      return false;
    return true;
  }
  // 15位身份证判断
  else if (!force18 && sId.length == 15) {
    if (!/^\d{15}$/i.test(sId))
      return false;
    if (aCityStr.indexOf(sId.substr(0, 2)) === -1)
      return false;
    sBirthday = "19" + sId.substr(6, 2) + "-" + Number(sId.substr(8, 2)) + "-" + Number(sId.substr(10, 2));
    var d = new Date(sBirthday.replace(/-/g, "/"));
    if (sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()))
      return false;
    return true;
  } else {
    return false;
  }
}
let form = {
  $: null,
  builder: function (paramObj) {
    var that = this
    let data = {};
    if (paramObj) {
      data = { ...paramObj }
    }
    return {
      isForm: function () {
        return true;
      },
      contains: function (key) {
        return typeof data[key] != 'undefined';
      },
      get: function (key) {
        return data[key]
      },
      addIfAbsent: function (key, value) {
        if (!this.contains(key)) {
          data[key] = value;
        }
        return this;
      },
      remove: function (key) {
        if (this.contains(key)) {
          delete data[key];
        }
      },
      add: function (key, value) {
        data[key] = value;
        return this;
      },
      toStr: function (clear = true) {
        let tempArr = [];
        for (var key in data) {
          tempArr.push(key + "=" + encodeURIComponent(data[key]));
        }
        if (clear) data = {};
        return tempArr.join('&');
      },
      clone: function () {
        return that.builder(data);
      },
      encrypt: function (encryptKeys) {
        var encrypt = new JSEncrypt();
        encryptKeys.forEach((key) => {
          if (data[key]) {
            encrypt.setPublicKey(config.publicKey);
            data[key] = (encrypt.encrypt(data[key]));
          }
        })
      }
    }
  },
  validator: function (opt) { // 表单参数检验器
    var option = opt || { tip: true }
    var reg = {
      checkengname: {
        rule: /^[A-Za-z]+$/,
        desc: "姓名(英文或拼音)"
      },
      checkcrse: {
        rule: /^[A-Za-z\s]{2,}$/,
        desc: "联系地址(英文或拼音)"
      },
      checkcrschina: {
        rule: /^[\u4E00-\u9FA5]{2,10}$/,
        desc: "出生地"
      },
      checkcrsaddress: {
        rule: /^.{2,}$/,
        desc: "地址"
      },
      chinacrseprovince: {
        rule: /^[\u4E00-\u9FA5]{2,10}$/,
        desc: "出生地"
      },
      chinacrsecity: {
        rule: /^[\u4E00-\u9FA5]{2,10}$/,
        desc: "出生地"
      },
      checkcrsebir: {
        rule: /^[A-Za-z\s]{2,}$/,
        desc: "出生地(英文或拼音)"
      },
      checkcrstaxcountry: {
        rule: /^[\u4E00-\u9FA5]*$/,
        desc: "纳税居民国(地区)"
      },
      checkcrscusttaxno: {
        rule: /^[0-9]*$/,
        desc: "纳税人识别号"
      },
      notEmpty: {
        rule: /^[\s\S]+$/,
        desc: ""
      },
      noSpace: { // 不能含有空格
        rule: /^[^\s\r\n]*$/,
        desc: ''
      },
      loginPw: {
        rule: config.formValidRule.loginPw.reg,
        desc: config.formValidRule.loginPw.errmsg
      },
      loginPwTwo: {
        rule: config.formValidRule.loginPw.reg,
        desc: config.formValidRule.loginPw.errmsg
      },
      queryPw: {
        rule: new RegExp(config.formValidRule.queryPw.reg),
        desc: config.formValidRule.queryPw.errmsg,
      },
      tradePw: {
        rule: config.formValidRule.tradePw.reg,
        desc: config.formValidRule.tradePw.errmsg
      },
      mobile: {
        rule: /^1[0-9]{10}$/,
        desc: "手机号码"
      },
      num: {
        rule: /^\d+$/,
        desc: ""
      },
      money: {
        rule: /^\d+(\.\d{0,2})?$/,
        desc: "金额"
      },
      word: {
        rule: /^[a-zA-Z0-9]+$/
      },
      zip: {
        rule: /^[0-9]{6}$/,
        desc: "邮编"
      },
      email: {
        rule: /^([a-zA-Z0-9_\-\.])+@[a-zA-Z0-9_-]{2,}(\.[a-zA-Z0-9_-]{2,4})+$/,
        desc: "email"
      },
      telphone: {
        rule: /^\d{3,5}\-\d{4,8}$/,
        desc: "固定电话"
      },
      fax: {
        rule: /^\d{3,5}\-\d{4,8}$/,
        desc: "传真"
      },
      age18: {
        rule: {
          test: function (value) {
            try {
              var birthday = value.substr(6, 8);
              var now = new Date();
              var year = now.getFullYear();
              var month = now.getMonth() + 1;
              var date = now.getDate();
              if (month < 10) {
                month = "0" + month
              } else {
                month = month + ""
              }
              if (date < 10) {
                date = "0" + date;
              } else {
                date = date + ""
              }
              return (parseInt(year + month + date) - parseInt(birthday)) > 180000
            } catch (e) {
              return true;
            }
          }
        },
        desc: ""
      },
      age65: {
        rule: {
          test: function (value) {
            try {
              var birthday = value.substr(6, 8);
              var now = new Date();
              var year = now.getFullYear();
              var month = now.getMonth() + 1;
              var date = now.getDate();
              if (month < 10) {
                month = "0" + month
              } else {
                month = month + ""
              }
              if (date < 10) {
                date = "0" + date;
              } else {
                date = date + ""
              }
              return (parseInt(year + month + date) - parseInt(birthday)) > 650000
            } catch (e) {
              return true;
            }
          }
        },
        desc: ""
      },
      age70: {
        rule: {
          test: function (value) {
            try {
              var birthday = value.substr(6, 8);
              var now = new Date();
              var year = now.getFullYear();
              var month = now.getMonth() + 1;
              var date = now.getDate();
              if (month < 10) {
                month = "0" + month
              } else {
                month = month + ""
              }
              if (date < 10) {
                date = "0" + date;
              } else {
                date = date + ""
              }
              return (parseInt(year + month + date) - parseInt(birthday)) > 700000
            } catch (e) {
              return true;
            }
          }
        },
        desc: ""
      },
      true: {
        rule: {
          test: function (value) {
            return value === true;
          }
        },
        desc: ""
      },
      script: {
        rule: {
          test: function (value) {
            return !(/<script[^>]*>.*<\/script>/i.test(value));
          }
        },
        desc: ""
      },
      reg: {
        rule: {
          test: function (value) {
            return value.reg.test(value.value);
          }
        },
        desc: ""
      },
      strlength: {
        rule: {
          test: function (value) {
            if (value.size) {
              if (value.value.length == value.size) {
                return true;
              } else {
                return false;
              }
            } else {
              if (value.value.length >= value.min && value.value.length <= value.max) {
                return true;
              } else {
                return false;
              }
            }
          }
        },
        desc: ""
      },
      // 证件号码，分 身份证或其他
      certificateNo: {
        rule: {
          test: function (value) {
            if (value.type == '0') { // 身份证
              return reg.certificate15And18.rule.test(value.value)
            } else { // 其他 最长40
              let maxLength = 30
              // 开中登40，不开中登最长30
              if (config.antiMoney.zdlegal.enable) {
                maxLength = 40
              }
              return value.value && value.value.length <= maxLength
            }
          }
        },
        desc: "证件号码格式不正确"
      },
      certificate: {
        rule: {
          test: function (value) {
            return checkIdNo(value, true)
          }
        },
        desc: "18位身份证"
      },
      certificate15And18: {
        rule: {
          test: function (value) {
            return checkIdNo(value)
          }
        },
        desc: "身份证"
      },
      bankcard: {
        rule: {
          test: function (value) {
            // 开中登最大 40 位，不开最大32位
            let reg = config.antiMoney.zdlegal.enable ? /^[\d]{12,40}$/ : /^[\d]{12,32}$/
            return reg.test(value);
          }
        },
        desc: "银行卡"
      },
      "=": {
        rule: {
          test: function (value) {
            return (value.a == value.b);
          }
        },
        desc: ""
      },
      "!=": {
        rule: {
          test: function (value) {
            return (value.a != value.b);
          }
        },
        desc: ""
      },
      ">": {
        rule: {
          test: function (value) {
            return parseFloat(value.a) > parseFloat(value.b);
          }
        }
      },
      "<": {
        rule: {
          test: function (value) {
            return parseFloat(value.a) < parseFloat(value.b);
          }
        }
      },
      ">=": {
        rule: {
          test: function (value) {
            return parseFloat(value.a) >= parseFloat(value.b);
          }
        }
      },
      "<=": {
        rule: {
          test: function (value) {
            return parseFloat(value.a) <= parseFloat(value.b);
          }
        }
      },
      chineseName: {
        rule: {
          test: function (value) {
            var chinese = /^[\u4E00-\u9FA5\uf900-\ufa2d]{2,15}$|^[\u4E00-\u9FA5\uf900-\ufa2d]{1,10}(·){0,1}[\u4E00-\u9FA5\uf900-\ufa2d]{1,15}$/;
            return chinese.test(value);
          }
        },
        desc: "中文姓名"
      },
      commonName: {
        rule: {
          test: function (value) {
            var common = /^[\u4E00-\u9FA5\uf900-\ufa2d]{2,15}$|^[\u4E00-\u9FA5\uf900-\ufa2d]{1,10}(·|\.){0,1}[\u4E00-\u9FA5\uf900-\ufa2d]{1,15}$|^[a-zA-Z]{1,20}$/;
            return common.test(value);
          }
        },
        desc: "中文或英文姓名"
      },
      noIllegalWords: {
        rule: {
          test: function (value) {
            return !value.match(RegExp(config.antiMoney.address.illegalWords))
          }
        }
      },
      shortAddress: {
        rule: {
          test: function (value) {
            return value.length <= 50
          }
        }
      },
      chineseWords: {
        rule: {
          test: function (value) {
            return !!value.str.match(RegExp("(.*[\u4e00-\u9fa5]{1}.*){" + value.size + "}"))
          }
        }
      },
      notAllNumber: {
        rule: {
          test: function (value) {
            return !(/^[0-9]+$/.test(value));
          }
        }
      },
      yearIncomMoney: {
        rule: {
          test: function (value) {
            if (Number(value) >= 500000 && String(value).length <= 16 && Number.isInteger(Number(value))) {
              return true
            }
          }
        },
        desc:'金额50万以上'
      }
    };

    var validQueue = [];
    var $ = this.$;
    function valid(type, value, desc, cb) {
      // 支持自定义规则
      let regObj;
      if (typeof type == 'function') {
        regObj = {
          rule: {
            test: type
          }
        };
      } else if (typeof type === 'object') {
        regObj = type
      } else {
        regObj = reg[type];
      }
      if (regObj) {
        if (value && regObj.rule.test(value)) {
          return true;
        } else {
          if (desc) {
            if (option.tip) {
              // $.toast(desc, () => {
              //   cb && cb()
              // });
            } else {
              cb && cb();
            }
          } else if (regObj.desc) {
            if (option.tip) {
              // $.toast("请输入正确的" + regObj.desc, () => {
              //   cb && cb()
              // });
            } else {
              cb && cb();
            }
          }
          return false;
        }
      }
    }
    return {
      hope: function (reg, value, desc) {
        return this.add(reg, value, desc);
      },
      add: function (reg, value, desc, cb) {
        validQueue.push({
          reg: reg,
          value: value,
          desc: desc,
          cb: cb
        });
        return this;
      },
      valid: function () {
        for (var index in validQueue) {
          if (false == valid(validQueue[index].reg, validQueue[index].value, validQueue[index].desc, validQueue[index].cb)) {
            validQueue = [];
            return false;
          }
        }
        validQueue = [];
        return true;
      }
    }
  }
}

export default form;